import { Component, Vue, Watch } from 'vue-property-decorator';
import template from './admin-list.vue';
import { User, ModalState, ModalComponents, Permission, Company } from '@/definitions';
import apiService from '@/services/api.service';
import { Action } from '@/store';
import { LocalUser } from '@/store/store.definitions';

@Component({
  mixins: [template],
})
export default class AdminList extends Vue {
  allCompanies: Company[] = [];
  companies: Company[] = [];
  searchString: string = '';
  loading: boolean = false;

  @Watch('$store.state.modal.active')
  modalStateChange(active: boolean) {
    if (!active) {
      this.getCompanies();
    }
  }

  @Watch('searchString')
  filterCompanies() {
    this.companies = this.allCompanies.filter(c =>
      c.name.toLowerCase().includes(this.searchString.toLowerCase()) ||
      (c.admins as string).toLowerCase().includes(this.searchString.toLowerCase())
    );
  }

  created() {
    this.loading = true;
    this.getCompanies();
  }

  get admin(): LocalUser {
    return this.$Store.state.user;
  }

  async getCompanies() {
    try {
      this.allCompanies = await apiService.getCompanies();
      this.filterCompanies();
      this.loading = false;
    } catch (e) {
      this.$Store.dispatch(Action.SHOW_ALERT, { text: 'alerts.override.retrieve_error', type: 'danger' });
      this.loading = false;
    }
  }

  deleteCompany(company: Company) {
    const modalData = {
      component: ModalComponents.DELETE_COMPANY,
      props: { companyId: company._id, company: company.name }
    };
    this.$Store.dispatch(Action.SHOW_MODAL, modalData);
  }

  override(company: Company): void {
    const modalData = {
      component: ModalComponents.OVERRIDE_PREMIUM,
      props: { isPremium: !!company.overridePremium, companyId: company._id }
    };
    this.$Store.dispatch(Action.SHOW_MODAL, modalData);
  }
}